import ClaudeCode from "./ClaudeCode";
import ClaudeCodeEn from "./ClaudeCode.en";
import NNAlgorithm from "./NNAlgorithm";
import NNAlgorithmEn from "./NNAlgorithm.en";
import ReedSolomon from "./ReedSolomon";
import ReedSolomonEn from "./ReedSolomon.en";
import TAE from "./TAE";
import TAEEn from "./TAE.en";

export const posts = [
  {
    id: 1,
    title: "La TAE de Trade Republic y el número de Euler",
    date: "2026-01-03",
    excerpt: `
      Todo el mundo sabe que a los economistas y brókers les gusta abrumar a la gente con una avalancha de siglas
      poco explicativas. Que si TIR, TIN, TIE, ... En particular, hoy descifraremos una de las más
      mencionadas en anuncios de cuentas remuneradas: la TAE. Veremos además la curiosa relación natural que
      guarda esta tasa financiera con el conocido número 'e'.
    `,
    slug: "tae",
    category: "Finanzas",
    content: <TAE/>,
    en: {
      title: "Trade Republic's TAE and Euler's number",
      excerpt: `
        Everyone knows economists and brokers like to overwhelm people with an avalanche of not-very-explanatory
        acronyms. It's TIR this, TIN that, TIE, ... In particular, today we'll decipher one of the most mentioned
        in ads for interest-bearing accounts: TAE. We'll also see the curious natural relationship this financial
        rate has with the well-known number 'e'.
      `,
      category: "Finance",
      content: <TAEEn/>,
    },
  },
  {
    id: 2,
    title: "Claude Code: cuando la IA escribe sobre sí misma",
    date: "2026-02-06",
    excerpt: `
      Este post lo ha escrito Claude, no yo. Literalmente. Le di unas instrucciones en un Markdown y me quedé
      mirando cómo trabajaba. Hoy hablamos de Claude Code, el cambio de paradigma en desarrollo de software,
      y la famosa regla del 80/20 del vibe coding.
    `,
    slug: "claude-code",
    category: "Vibe coding",
    content: <ClaudeCode/>,
    en: {
      title: "Claude Code: when AI writes about itself",
      excerpt: `
        This post was written by Claude, not me. Literally. I gave it some instructions in a Markdown file and sat
        there watching it work. Today we're talking about Claude Code, the paradigm shift in software development,
        and the famous 80/20 rule of vibe coding.
      `,
      category: "Vibe coding",
      content: <ClaudeCodeEn/>,
    },
  },
  {
    id: 3,
    title: "¿Cómo \"aprenden\" realmente las redes neuronales?",
    date: "2026-05-10",
    excerpt: `
      Cansado de los vídeos de 5 minutos que te "explican" cómo funcionan las redes neuronales, decidí
      repasar los fundamentos matemáticos que se esconden detrás de esta piedra angular del aprendizaje
      automático. En este artículo, un tanto técnico, te cuento las ideas más importantes.
    `,
    slug: "nn-fundamentals",
    category: "Deep learning",
    content: <NNAlgorithm/>,
    en: {
      title: "How do neural networks really \"learn\"?",
      excerpt: `
        Tired of the 5-minute videos that "explain" how neural networks work, I decided to review the
        mathematical foundations hidden behind this cornerstone of machine learning. In this somewhat
        technical article, I walk you through the most important ideas.
      `,
      category: "Deep learning",
      content: <NNAlgorithmEn/>,
    },
  },
  {
    id: 4,
    title: "Reed-Solomon: por qué un QR medio borrado sigue escaneándose",
    date: "2026-09-27",
    excerpt: `
      En los años 60, dos tipos idearon un fascinante código de corrección de errores usando
      polinomios y cuerpos finitos. Gracias a ellos, hoy en día puedes usar códigos de barras a medias,
      escanear QRs mal iluminados o reproducir DVDs rayados... ¿Listo para descubrir cómo funciona Reed-Solomon? 
    `,
    slug: "reed-solomon",
    category: "Teoría de códigos",
    content: <ReedSolomon/>,
    en: {
      title: "Reed-Solomon: why a half-erased QR code still scans",
      excerpt: `
        In the 60s, two guys came up with a fascinating error-correcting code using
        polynomials and finite fields. Thanks to them, today you can use half-damaged barcodes,
        scan poorly lit QR codes or play scratched DVDs... Ready to find out how Reed-Solomon works?
      `,
      category: "Coding theory",
      content: <ReedSolomonEn/>,
    },
  },
];

// Devuelve el post en el idioma pedido. Si no tiene versión `en`, se queda en español.
export function localizePost(post, lang) {
  if (lang === "en" && post.en) return { ...post, ...post.en, translated: true };
  return { ...post, translated: lang === "es" };
}
